module.exports = __webpack_public_path__ + "static/media/westinchennai04.7e37ad2d.jpg";